/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';
import { DayTypeEnum } from './types';

export const DayContainer = styled.div<{
  isFrom: boolean;
  isTo: boolean;
  isFromInterval: boolean;
  isEqual: boolean;
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  background-color: ${({ isFrom, isTo, isFromInterval, isEqual, theme }) =>
    (isFrom || isTo || isFromInterval) && !isEqual ? theme.datePicker.background : 'transparent'};
  ${({ isFrom, isTo }) =>
    isFrom
      ? css`
          border-top-left-radius: 42px;
          border-bottom-left-radius: 42px;
        `
      : isTo
      ? css`
          border-top-right-radius: 42px;
          border-bottom-right-radius: 42px;
        `
      : ''}
`;

export const ActualDayBullet = styled.div<{ isFrom: boolean; isTo: boolean }>`
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: ${({ isFrom, isTo, theme }) =>
    isFrom || isTo ? theme.white : theme.datePicker.default};
  position: absolute;
  top: 6px;
  left: calc(50% - 2px);
`;

export const SpanDay = styled.span<{
  isFrom: boolean;
  isTo: boolean;
  isFromInterval: boolean;
  isEqual: boolean;
  isBlocked: boolean;
  isWeekend: boolean;
  type: DayTypeEnum;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  font-family: 'Mulish', sans-serif;
  font-size: 14px;
  line-height: 18px;
  box-sizing: border-box;
  color: ${({ isFrom, isTo, isBlocked, theme }) =>
    isFrom || isTo ? theme.white : isBlocked ? theme.grayCC : theme.gray4D};
  background-color: ${({ isFrom, isTo, theme }) =>
    isFrom || isTo ? theme.datePicker.default : 'transparent'};
  font-weight: ${({ isWeekend }) => (isWeekend ? '700' : '400')};
  border-radius: ${({ isFrom, isTo }) => (isFrom || isTo ? '100%' : '0')};
  cursor: ${({ isBlocked }) => (isBlocked ? 'auto' : 'pointer')};

  ${({ isBlocked }) =>
    !isBlocked &&
    css`
      &:hover {
        border: 1px solid ${({ theme }) => theme.datePicker.default};
        border-radius: 100%;
      }
    `}
`;
